import { flowRight } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import withEnvironment from '../../hoc/with-environment';
import withTranslate from '../../hoc/with-translate';
import styles from './profile-stats.scss';

export const ProfileStatsWithLinks = ({ className, postCount, followerCount, followingCount, user, navigation: { FollowersLink, FollowingLink }, t }) =>
  <div className={classNames(styles.container, className)}>
    <div className={styles.section}>
      <p className={classNames(styles.count, 'profile-stats__post-count')}>
        {t('profile-stats.posts-count', { count: postCount })}
      </p>
      <p className={styles.label}>
        {t('profile-stats.posts-count-label', { count: postCount })}
      </p>
    </div>

    <FollowersLink
      className={classNames(styles.section, 'button-hover-color', 'profile-stats__followers-link')}
      user={user}
    >
      <p className={classNames(styles.count, 'profile-stats__follower-count')}>
        {t('profile-stats.follower-count', { count: followerCount })}
      </p>
      <p className={styles.label}>
        {t('profile-stats.follower-count-label', { count: followerCount })}
      </p>
    </FollowersLink>

    <FollowingLink
      className={classNames(styles.section, 'button-hover-color', 'profile-stats__following-link')}
      user={user}
    >
      <p className={classNames(styles.count, 'profile-stats__following-count')}>
        {t('profile-stats.following-count', { count: followingCount })}
      </p>
      <p className={styles.label}>
        {t('profile-stats.following-count-label')}
      </p>
    </FollowingLink>
  </div>;

ProfileStatsWithLinks.propTypes = {
  className: PropTypes.string,
  postCount: PropTypes.number.isRequired,
  followerCount: PropTypes.number.isRequired,
  followingCount: PropTypes.number.isRequired,
  user: PropTypes.object.isRequired,
  navigation: PropTypes.object,
  t: PropTypes.func,
};

export default flowRight(
  withEnvironment({ navigation: 'navigation' }),
  withTranslate
)(ProfileStatsWithLinks);



// WEBPACK FOOTER //
// ./app/components/profile-stats/profile-stats.js